module.exports = __webpack_public_path__ + "static/sc-06-1534e11acb4f56aad850070afe98e64b.png";